import { computed } from "vue";

import { useViewState } from "./useViewState";

export function useTableConfig() {
  const viewState = useViewState();

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Responsibility",
          sortable: true,
          value: "responsbility",
        },
        {
          text: "Badge Holders",
          sortable: true,
          value: "badge_holders",
        },
        {
          text: "Coaches",
          sortable: true,
          value: "coach_badges",
        },
        {
          text: "Masters",
          sortable: true,
          value: "master_badges",
        },
      ],
      columns: [
        {
          field: "",
          component: "OrgObjectCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getOrgObjectCardProps(item),
          }),
        },
        {
          field: "",
          component: "BadgesCounterLevel",
          props: (item) => ({
            class: "my-4",
            ...viewState.getBadgesCounterLevelProps(item),
          }),
          events: (item) => ({
            onClick: () => {
              viewState.onClickBadgesCounterLevel(item);
            },
          }),
        },
        {
          field: "",
          component: "AvatarPeople",
          props: (item) => ({
            class: "my-4",
            ...viewState.getCoachAvatarPeopleProps(item),
          }),
          events: (item) => ({
            onAvatarClick: () => {
              viewState.onClickCoachPeopleAvatar(item);
            },
          }),
        },
        {
          field: "",
          component: "AvatarPeople1",
          props: (item) => ({
            class: "my-4",
            ...viewState.getMasterAvatarPeopleProps(item),
          }),
          events: (item) => ({
            onAvatarClick: () => {
              viewState.onClickMasterPeopleAvatar(item);
            },
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
      },
      hideTopSection: true,
      hideActiveNo: false,
      activeRecords: {
        field: "current_status",
        value: "active",
      },
      actionLabel: "Recalculate All",
      showActionButton: viewState.state.filters.needsRecalculation
        ? false
        : true,
      must: viewState.state.filters.needsRecalculation ? true : false,
      hideGridView: true,
      hideButtonIcon: true,
      title: "Employees Readiness",
      hideButtonInMessage: true,
      hideFilterBtn: true,
      getRowStyle: (item) => ({
        backgroundColor:
          item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
